var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLamp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "hinava_random_uuid_198721421413880775108835593745034924889",
    x1: "50%",
    x2: "50%",
    y1: "32.846%",
    y2: "90.794%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#74FFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#00FFA9"
  })), /*#__PURE__*/React.createElement("path", {
    id: "hinava_random_uuid_220426655839639340169101347812102839100",
    d: "M16 8.009C15.97 3.588 12.393 0 8 0S.029 3.588 0 8.009v.053c.015 3.22 1.358 5.002 2.545 6.575.992 1.316 1.775 2.355 1.775 4.085v2.465C4.32 22.738 5.572 24 7.111 24H8.89c1.539 0 2.79-1.262 2.79-2.813v-2.465c0-1.73.784-2.769 1.776-4.085 1.187-1.573 2.53-3.355 2.545-6.575V8.01zM9.82 21.187c0 .517-.418.938-.931.938H7.11c-.513 0-.93-.42-.93-.938V19.36h3.638v1.828zm2.154-7.684c-.86 1.141-1.745 2.315-2.047 3.981H6.073c-.302-1.666-1.186-2.84-2.047-3.981-1.11-1.472-2.158-2.862-2.166-5.464C1.873 4.638 4.623 1.875 8 1.875s6.127 2.763 6.14 6.164c-.008 2.602-1.057 3.992-2.166 5.464z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(7 3)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "hinava_random_uuid_322828363807574689307900216829222887061",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hinava_random_uuid_220426655839639340169101347812102839100"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    xlinkHref: "#hinava_random_uuid_220426655839639340169101347812102839100"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "url(#hinava_random_uuid_198721421413880775108835593745034924889)",
    mask: "url(#hinava_random_uuid_322828363807574689307900216829222887061)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 8,
    transform: "translate(-7 -3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLamp);
export default __webpack_public_path__ + "static/media/lamp.edf507d84f6d1534ffaadd7e97337c82.svg";
export { ForwardRef as ReactComponent };